import todo from '../image/project/todolists.png'
import card from '../image/project/Card.png'
import password from '../image/project/password.png'
import social from '../image/project/social.png'

export const SliderData = [
    {
        image: todo,
        title: 'Todolist',
        stack: 'Technology stack:',
        text: 'SCSS, JavaScript, TypeScript, React, Redux, Axios, Reselect; Using TypeScript forbest code control; ' +
            'Reusable components development; Refactoring, bug fixing, deploying; Organizing correct apparchitecture'
    },
    {
        image: card,
        title: 'Learn cards',
        description: 'Team project in which I participated as React Front-end Developer',
        stack: 'Technology stack:',
        text: 'JavaScript, TypeScript, React, Redux, Redux-thunk, Axios, Classnames, SCSS; ' +
            'UsingTypeScript for best code control; Team developement,refactoring, bug fixing, deploying.'
    },
    {
        image: social,
        title: 'Social network',
        stack: 'Technology stack:',
        text: 'JavaScript, TypeScript, React, Redux, Redux-thunk, Redux-form, Axios, SCSS; ' +
            'Using TypeScript for best code control; Reusable components development;' +
             'Refactoring, bug fixing, deploying; Organizing correct apparchitecture; Covering code with unit tests.'
    },
    {
        image: password,
        title: 'Password generator',
        stack: 'Technology stack:',
        text: 'JavaScript, React, SCSS; ' +
            'Bug fixing, deploying.'
    },

]